module.exports = __webpack_public_path__ + "img/tafsir1.fef28190.png";